let state = {

  AllPerguntas: [],// vai o id da disciplia de parametro
  allPerguntas: [], // pega todas
  allAvaliacoes: [],
  allOfertaPerguntas: [],
  getAvaliacoesRealizadas: [],
  setAvaliacao: '',
  getPergunta:{}

}

export default state
